import { z } from 'zod'

export default z.object({
  __typename: z.literal('OrderReport').default('OrderReport'),
  id: z.number(),
})
